import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b23e2fe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "exception_toast",
  class: "toast toast-position",
  role: "alert",
  "aria-live": "assertive",
  "aria-atomic": "true"
}
const _hoisted_2 = { class: "mr-auto" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "ml-2 mb-1 close",
  "data-bs-dismiss": "toast",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
], -1))
const _hoisted_4 = { class: "toast-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`toast-header ${_ctx.isPositive ? 'success-header' : 'alert-header'}`)
    }, [
      _createElementVNode("strong", _hoisted_2, _toDisplayString(_ctx.isPositive ? "Success" : "Error"), 1),
      _hoisted_3
    ], 2),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.prospectCallbackErrorMsg), 1)
  ]))
}